// extracted by mini-css-extract-plugin
export default {"introSection":"AirPodsPage_introSection__BFbK3"};